import React, { useContext } from 'react'
import { AppContext } from '../..'
import './AppLoading.css'

function AppLoading() {
  const { state } = useContext(AppContext)

  if (state.diags.appLoading) {
    return (
      <div id="app-loading">
        Ready in just a minute...
      </div>
    )
  } else {
    return null
  }
}

export default AppLoading
